import { render, staticRenderFns } from "./agb.vue?vue&type=template&id=a6d125ac&scoped=true&"
import script from "./agb.vue?vue&type=script&lang=js&"
export * from "./agb.vue?vue&type=script&lang=js&"
import style0 from "./agb.vue?vue&type=style&index=0&id=a6d125ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d125ac",
  null
  
)

export default component.exports